module.exports = __webpack_public_path__ + "img/alipay_v2.1e8b327d.jpg";